const defaultStore = {
  showDeleteDishConfirmPopup: false,
  deletingDishName: '',
  deletingDishId: '',
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case 'DELETE_DISH_CONFIRM':
      return {
        ...state,
        showDeleteDishConfirmPopup: true,
        deletingDishName: action.name,
        deletingDishId: action.id,
      };

    case 'DELETE_CANCEL':
      return {
        ...state,
        showDeleteDishConfirmPopup: false,
        deletingDishName: '',
        deletingDishId: '',
      };

    case 'DELETE_DISH_SUCCESS':
      return {
        ...state,
        showDeleteDishConfirmPopup: false,
      };

    case 'DELETE_DISH_ERROR':
      return {
        ...state,
        showDeleteDishConfirmPopup: false,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dishDelete.js